module.exports = ".normal {\r\n    font-style: normal;\r\n}\r\n\r\n.italic {\r\n    font-style: italic;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/main-content/content-container/port-call/registration/forms/cargo/consignment-form/consignment-form.component.css
// module id = ./src/app/main-content/content-container/port-call/registration/forms/cargo/consignment-form/consignment-form.component.css
// module chunks = main